import { get } from "lodash"

const hasFrame = (artWallProduct) => {
  return artWallProduct && get(artWallProduct, 'selectedFrame', false)
}

export default hasFrame